/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import { Pipe, PipeTransform } from '@angular/core';
import { IconShapeCollection } from '@cds/core/icon/interfaces/icon.interfaces';

@Pipe({
  name: 'appIconBadge',
})
export class IconBadgePipe implements PipeTransform {
  transform(badge: string, iconDetails: IconShapeCollection) {
    if (badge?.includes('triangle')) {
      return iconDetails.outlineAlerted || iconDetails.solidAlerted ? badge : null;
    } else if (badge) {
      return iconDetails.outlineBadged || iconDetails.solidBadged ? badge : null;
    } else {
      return null;
    }
  }
}
